import { Injectable } from '@angular/core';
import { Auth } from 'aws-amplify';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class CognitoService {

  constructor(private http: HttpClient) {
  }

  signUp(username:string, email: string, password: string, phoneNumber: string): Promise<any> {
    const body = {
      username: username,
      password: password,
      attributes: {
          email: email,
          phone_number: phoneNumber,
      }
    }

    return Auth.signUp(body);
  }

  confirmSignUp(email: string, code: string):Promise<any> {
    return Auth.confirmSignUp(email, code);
  }

  signIn(email: string, password: string):Promise<any> {
    return Auth.signIn(email, password);
  }

  signOut():Promise<any> {
    return Auth.signOut();
  }

  forgotPassword(username:string):Promise<any> {
    return Auth.forgotPassword(username);
  }

  forgotPasswordSubmit(email: string, code: string, password: string):Promise<any> {
    return Auth.forgotPasswordSubmit(email, code, password);
  }

  resendConfirmationCode(username: string): Promise<any> {
    return Auth.resendSignUp(username);
  }

  async isAuthenticated():Promise<boolean> {
    return await Auth.currentAuthenticatedUser() ? true : false;
  }

  getCurrentUser():Promise<any> {
    return Auth.currentAuthenticatedUser();
  }

}
